import initialState from 'reducers/initialStates/selfService';
import { uiEventTypes } from 'events/ui';
import { selfServiceEventTypes } from 'events/selfService';
import { MIN_SEARCH_TERM_LEN } from 'actions/selfService/getSearchResults';

export default function selfServiceReducer(state = initialState, action) {
  switch (action.type) {
    case selfServiceEventTypes.SS_UPDATE_SEARCH_RESULTS_SUCCESS:
      return handleUpdateSearchResultsSuccess(state, action);

    case selfServiceEventTypes.UPDATE_RESULTS_SCROLLTOP:
      return handleUpdateResultsScrollTop(state, action);

    case selfServiceEventTypes.SS_UPDATE_SELECTED_ANSWER:
      return handleUpdateSelectedAnswer(state, action);

    case selfServiceEventTypes.SS_UPDATE_SELECTED_ANSWER_SUCCESS:
      return handleUpdateSelectedAnswerSuccess(state, action);

    case selfServiceEventTypes.SS_CLEAR_SELECTED_ANSWER:
      return handleClearSelectedAnswer(state);

    case selfServiceEventTypes.SS_UPDATE_SEARCH_TERM:
      return handleUpdateSearchTerm(state, action);

    case uiEventTypes.WIDGET_NAVIGATE_BACK:
      return handleNavigateBack(state);

    case uiEventTypes.WIDGET_NAVIGATE_FORWARD:
      return handleNavigateForward(state);

    case selfServiceEventTypes.SS_THROTTLE_CHAT:
      return handleThrottleChat(state);

    case selfServiceEventTypes.SS_UNTHROTTLE_CHAT:
      return handleUnthrottleChat(state);

    case selfServiceEventTypes.FINALIZE_TIMELINE:
      return handleFinalizedTimeline(state, action);

    default:
      return state;
  }
}

function handleUpdateSearchResultsSuccess(state, action) {
  const { timestamp } = action.payload;
  const existingTimestamp = state.search.timestamp;

  // Ignore search result if the existing result is newer then result in payload
  if (existingTimestamp && new Date(existingTimestamp) >= new Date(timestamp)) {
    return { ...state };
  }

  return {
    ...state,
    search: { isLoading: false, ...action.payload },
  };
}

function handleUpdateResultsScrollTop(state, action) {
  return { ...state, resultsScrollTop: action.payload };
}

function handleUpdateSelectedAnswer(state, action) {
  const timeline = state.timeline.concat([{ ...action.payload, searchTerm: state.searchTerm }]);

  return {
    ...state,
    selectedAnswer: { id: action.payload.answerId, isLoading: true },
    timeline,
  };
}

function handleUpdateSelectedAnswerSuccess(state, action) {
  return {
    ...state,
    selectedAnswer: { isLoading: false, ...action.payload.answer },
  };
}

function handleClearSelectedAnswer(state) {
  return { ...state, selectedAnswer: null };
}

function handleUpdateSearchTerm(state, action) {
  const searchTerm = action.payload;

  if (!searchTerm || searchTerm.length < MIN_SEARCH_TERM_LEN) {
    return {
      ...state,
      isNavigatingBack: false,
      resultsScrollTop: 0,
      searchTerm,
      search: {
        isLoading: false,
        searchTerm: '',
        results: [],
        timestamp: null,
      },
    };
  }

  return {
    ...state,
    search: {
      ...state.search,
      isLoading: true,
    },
    searchTerm,
    areSearchResultsLoading: true,
  };
}

function handleNavigateBack(state) {
  return { ...state, isNavigatingBack: true };
}

function handleNavigateForward(state) {
  return { ...state, isNavigatingBack: false };
}

function handleThrottleChat(state) {
  return { ...state, isThrottled: true };
}

function handleUnthrottleChat(state) {
  return { ...state, isThrottled: false };
}

function handleFinalizedTimeline(state, action) {
  return { ...state, finalizedTimeline: action.payload.finalizedTimeline };
}
